import React, { useState } from "react";
import {
  faFile,
  faFolder,
  faFolderOpen,
} from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { UserContext, UserContextProvider } from "./users/UserContext";
import { useContext } from "react";
import ModalCreateNewFolder from "./treeModalWindows/ModalCreateNewFolder";
import ModalRename from "./treeModalWindows/ModalRename";
import ModalDelete from "./treeModalWindows/ModalDelete";
import ModalCopyScenario from "./treeModalWindows/ModalCopyScenario";
import authStorage from "../service/authStorage";
import { useNavigate } from "react-router-dom";
import axiosBaseUrl from "../api/axiosBaseURL";
import axios from "axios";
import ModalUploadFile from "./treeModalWindows/ModalUploadFile";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { useSelector } from "react-redux";
import FolderContextButton from "./treeContextButtons/FolderContextButton";
import FileContextButton from "./treeContextButtons/FileContextButton";
import headerService from "../service/headerService";
import comparator from "../service/comparator";
import ModalDuplicate from "./treeModalWindows/ModalDuplicate";

const Node2 = ({ node, props }) => {
  const user = useContext(UserContext);
  const [isVisibleFolderContains, setIsVisibleFolderContains] = useState(true);
  const isExistsSubFolders = node.folders?.length > 0 ? true : false;

  const [isNeedRefreshAllTree, setIsNeedRefreshAllTree] = useState(
    props?.isNeedRefreshAllTree
  );
  const [simulatedScenarioId, setSimulatedScenarioId] = useState(
    props?.simulatedScenarioId
  );

  const dispatch = useDispatch();
  const isShowButtonsGroup = useSelector((state) => state.isShowButtonsGroup);
  const isShowFolderContextMenu = useSelector(
    (state) => state.isShowFolderContextMenu
  );
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
  const scenarioSimulateID = useSelector((state) => state?.scenarioId);
  const templateSimulateID = useSelector((state) => state?.templateId);
  const [styleFileContextMenu, setStyleFileContextMenu] = useState("scenario-context-menu");

  // show/hide scenarios context menu buttons
  const setIsShowButtonsGroup = (command) => {
    dispatch({
      type: "SET_IS_SHOW_BUTTONS_GROUP",
      payload: command,
    });
  };

  // show/hide folders context menu buttons
  const setIsShowFolderContextMenu = (command) => {
    dispatch({
      type: "SET_IS_SHOW_FOLDER_CONTEXT_MENU",
      payload: command,
    });
  };

  // DOUBLE CLICK SIMULATE
  const runSimulate = (event, scenario) => {
    event.preventDefault();
    if (event.detail === 2) {
      if (scenario.template) {
        dispatch({ type: "NEW_TEMPLATE_SIMULATED_ID", payload: scenario.id });
        dispatch({ type: "NEW_SCENARIO_SIMULATED_ID", payload: 0 });
        dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: true });
      } else {
        dispatch({ type: "NEW_SCENARIO_SIMULATED_ID", payload: scenario.id });
        dispatch({ type: "NEW_TEMPLATE_SIMULATED_ID", payload: 0 });
        dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: false });
      }
      dispatch({ type: "RENAME_SCENARIO", payload: scenario.name });
      dispatch({ type: "IS_CHANGED_CURRENT_SCENARIO", payload: false });
      dispatch({
        type: "IS_NEED_REFRESH_SIMULATION",
        payload: true,
      });
    }
  };

  const Scenarios = ({ data = [] }) => {
    return (
      <div>
        {data.sort(comparator).map((scenario) => (
          <div
            key={scenario.id}
            onMouseLeave={(e) => setIsShowButtonsGroup("")}
          >
            <div className="flex justify file-list">
              <div className="flex file-row">
                <div>
                  <FontAwesomeIcon
                    className="file-icon not-select-text"
                    icon={faFile}
                    size="lg"
                    onClick={(e) => runSimulate(e, scenario)}
                  />
                </div>
                <div
                  className={
                    (scenario.id === scenarioSimulateID ||
                      scenario.id === templateSimulateID) &&
                    scenario.id !== null
                      ? "not-select-text file-name selected-scenario"
                      : "not-select-text file-name non-selected-scenario"
                  }
                  onClick={(e) => runSimulate(e, scenario)}
                >
                  {scenario.name}
                </div>
              </div>
              {((user?.role === "ADMIN" && scenario?.template) ||
                (user?.role === "CLIENT" && !scenario?.template) ||
                (user?.role === "CLIENT" && scenario?.template)) && (
                <div>
                  <img
                    src={`${APP_PATH}/contextmenu-button.svg`}
                    width="15"
                    height="15"
                    className="context-menu-button"
                    onClick={(e) => setIsShowButtonsGroup(scenario.id)}
                  />
                </div>
              )}
            </div>

            <div>
              <div className="scenario-context-menu">
                {/* {isShowButtonsGroup === scenario.id && ( */}
                  <FileContextMenu
                    id={scenario?.id}
                    isTemplate={scenario?.template}
                    scenarioName={scenario?.name}
                    simulatedScenarioId={simulatedScenarioId}
                    setSimulatedScenarioId={setSimulatedScenarioId}
                  />
                {/* )} */}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div>
        <div onMouseLeave={(e) => setIsShowFolderContextMenu("")}>
          <div>
            <div className="flex justify folder">
              <div
                className="flex"
                onClick={(e) =>
                  setIsVisibleFolderContains((visible) => !visible)
                }
              >
                <div>
                  {isVisibleFolderContains ? (
                    <FontAwesomeIcon
                      className="folder-icon"
                      icon={faFolderOpen}
                      size="lg"
                    />
                  ) : (
                    <FontAwesomeIcon
                      className="folder-icon"
                      icon={faFolder}
                      size="lg"
                    />
                  )}
                </div>
                <div className="not-select-text file-name">{node.name}</div>
              </div>
              {((user?.role === "ADMIN" && node?.template) ||
                (user?.role === "CLIENT" && !node?.template)) && (
                <div>
                  <img
                    className="context-menu-icon"
                    src={`${APP_PATH}/contextmenu-button.svg`}
                    width="15"
                    height="15"
                    onClick={(e) => setIsShowFolderContextMenu(node.id)}
                  />
                </div>
              )}
              <div className="folder-context-menu">
                {/* {isShowFolderContextMenu === node?.id && ( */}
                  <FolderContextMenu
                    id={node?.id}
                    parentFolderName={node?.name}
                    isTemplate={node?.template}
                    isNeedRefreshAllTree={isNeedRefreshAllTree}
                    setIsNeedRefreshAllTree={setIsNeedRefreshAllTree}
                  />
                {/* )} */}
              </div>
            </div>
            <div>
              {isExistsSubFolders && isVisibleFolderContains && (
                <div className="sub-folders">
                  <div>
                    {node.folders?.sort(comparator).map((folder) => (
                      <Node2 node={folder} key={folder.id} />
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div>
              {node.scenarios?.length > 0 && isVisibleFolderContains && (
                <Scenarios data={node?.scenarios} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FileContextMenu = (props) => {
  const navigate = useNavigate();
  const user = useContext(UserContext);
  const [showButtonsGroup, setShowButtonsGroup] = useState("");
  const [scenarioId, setScenarioId] = useState();
  const TEMPLATE_PATH_PREFIX =
    process.env.REACT_APP_ARI_URL + "/tree/templatestree/scenarios/";
  const SCENARIO_PATH_PREFIX =
    process.env.REACT_APP_ARI_URL + "/tree/scenariostree/scenarios/";
  const FILE_PATH_POSTFIX = "/file";
  const BEARER = authStorage();
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState();

  const [requestDTO, setRequestDTO] = useState();
  const [requestPath, setRequestPath] = useState();

  const [isShowRenameScenarioWindow, setIsShowRenameScenarioWindow] =
    useState();
  const [isActiveRenameButton, setIsActiveRenameButton] = useState();
  const [newScenarioName, setNewScenarioName] = useState();
  const [isNeedRenameScenario, setIsNeedRenameScenario] = useState();
  const RENAME_SCENARIO = `Rename scenario '${props.scenarioName}'`;
  const INPUT_RENAME_SCENARIO_TOOLTIP = "New scenario name";

  const [isShowDeleteScenarioWindow, setIsShowDeleteScenarioWindow] =
    useState();
  const [isNeedDeleteScenario, setIsNeedDeleteScenario] = useState();
  const DELETE_SCENARIO = `Delete scenario '${props.scenarioName}'?`;
  const DELETE_SCENARIO_BUTTON_TITTLE = "DELETE SCENARIO";
  const simScenarioId = useSelector((state) => state.scenarioId);
  const simTemplateId = useSelector((state) => state.templateId);

  const [isShowDuplicateScenarioWindow, setIsShowDuplicateScenarioWindow] =
    useState();
  const [duplicateScenarioName, setDuplicateScenarioName] = useState(
    "Copy of " + props?.scenarioName
  );
  const [isNeedDuplicateScenario, setIsNeedDuplicateScenario] = useState();
  const [isActiveDuplicateButton, setIsActiveDuplicateButton] = useState(true);
  const DUPLICATE_SCENARIO = `Duplicate scenario '${props.scenarioName}'`;
  const INPUT_DUPLICATE_SCENARIO_TOOLTIP = "Duplicate scenario name";
  const DUPLICATE_TEMPLATE_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/templatestree/templates/duplicate";
  const DUPLICATE_SCENARIO_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/scenariostree/scenarios/duplicate/";

  const TEMPLATE_PATH = process.env.REACT_APP_ARI_URL + "/templates";
  const SCENARIO_PATH = process.env.REACT_APP_ARI_URL + "/scenarios";
  const scenarioSimulateID = useSelector((state) => state?.scenarioId);
  const templateSimulateID = useSelector((state) => state?.templateId);

  const tree = useSelector((state) => state?.tree);
  const [isShowCopyScenarioWindow, setIsShowCopyScenarioWindow] = useState();
  const [isNeedCopyScenario, setIsNeedCopyScenario] = useState();
  const [copyScenarioTitle, setCopyScenarioTitle] = useState();
  const [isActiveCopyScenarioButton, setIsActiveCopyScenarioButton] =
    useState();
  const destinationFolderId = useSelector((state) => state.destinationFolderId);
  const COPY_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/scenariostree/folders/";
  const COPY_PATH_POSTFIX = "/bytemplate/";

  const [onPressEnterModalRenameScenario, setOnPressEnterModalRenameScenario] =
    useState(false);
  const [
    onPressEnterModalDuplicateScenario,
    setOnPressEnterModalDuplicateScenario,
  ] = useState(false);
  const isShowButtonsGroup = useSelector((state) => state.isShowButtonsGroup);

  // hide scenarios and folders context menu buttons,
  // when send request or close modal windows
  const hideAllContextButtons = () => {
    dispatch({
      type: "SET_IS_SHOW_BUTTONS_GROUP",
      payload: "",
    });
    dispatch({
      type: "SET_IS_SHOW_FOLDER_CONTEXT_MENU",
      payload: "",
    });
  };

  // flag to update scenarios tree
  const updateTree = () => {
    dispatch({
      type: "UPDATE_FOLDER_TREE",
      payload: 1,
    });
  };

  // update scenario name and update simulation when rename scenario from scenario tree while scenario open for simulation
  const updateScenarioName = () => {
    if (!props.template) {
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: 0,
      });
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: props?.id,
      });
      dispatch({
        type: "RENAME_SCENARIO",
        payload: newScenarioName,
      });
    }
  };

  // reset
  const fullReset = () => {
    setRequestDTO();
    setRequestPath();
    setIsShowRenameScenarioWindow(false);
    setIsActiveRenameButton(false);
    setIsNeedRenameScenario(false);
    setNewScenarioName();
    setIsShowDeleteScenarioWindow(false);
    setIsNeedDeleteScenario(false);
    setIsShowDuplicateScenarioWindow(false);
    setIsNeedDuplicateScenario(false);
    setIsNeedCopyScenario(false);
    hideAllContextButtons();
    updateTree();
  };

  // redirect without auth
  const redirectIfNotAuth = (response) => {
    if (response.status === 401) {
      navigate("/login");
    }
  };

  // show only for templates tree
  const isTemplateContext = () => {
    return user?.role === "ADMIN" && props.isTemplate;
  };

  // show only for scenarios tree
  const isScenarioContext = () => {
    return user?.role === "CLIENT" && !props.isTemplate;
  };

  // download scenario
  const handleDownloadFile = async (event) => {
    setScenarioId(props?.id);
    event.preventDefault();
    const downloadScenarioURL =
      event.target.id === "downloadTemplate"
        ? TEMPLATE_PATH_PREFIX + props?.id + FILE_PATH_POSTFIX
        : SCENARIO_PATH_PREFIX + props?.id + FILE_PATH_POSTFIX;
    axios({
      url: downloadScenarioURL,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: BEARER,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${props.scenarioName}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
    fullReset();
  };

  // CONTEXT MENU SIMULATE
  // refresh simulate flag for simulation update
  const simulateIt = (event) => {
    event.preventDefault();
    console.log(props?.id);
    if (props.isTemplate) {
      dispatch({ type: "NEW_TEMPLATE_SIMULATED_ID", payload: props?.id });
      dispatch({ type: "NEW_SCENARIO_SIMULATED_ID", payload: 0 });
      dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: true });
    } else {
      dispatch({ type: "NEW_SCENARIO_SIMULATED_ID", payload: props?.id });
      dispatch({ type: "NEW_TEMPLATE_SIMULATED_ID", payload: 0 });
      dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: false });
    }
    dispatch({ type: "RENAME_SCENARIO", payload: props?.scenarioName });
    dispatch({ type: "IS_CHANGED_CURRENT_SCENARIO", payload: false });
    dispatch({
      type: "IS_NEED_REFRESH_SIMULATION",
      payload: true,
    });
    hideAllContextButtons();
  };

  // show rename scenario modal
  const showRenameScenarioWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "renameTemplate") {
      setRequestPath(TEMPLATE_PATH);
    }
    if (event.target.id === "renameScenario") {
      setRequestPath(SCENARIO_PATH);
    }
    setIsShowRenameScenarioWindow(true);
  };

  // hide rename scenario modal
  const closeRenameScenarioWindow = (event) => {
    event.preventDefault();
    setIsShowRenameScenarioWindow(false);
    hideAllContextButtons();
  };

  // flag to request rename scenario
  const handleSubmitRenameScenario = (event) => {
    event.preventDefault();
    setRequestDTO({
      newScenarioName: newScenarioName,
      scenarioId: props.id,
    });
    setIsNeedRenameScenario(true);
  };

  // update new scenario name
  const handleChangeNewScenarioName = (event) => {
    event.preventDefault();
    if (
      event.target.value.length &&
      event.target.value !== props.scenarioName
    ) {
      setNewScenarioName(event.target?.value);
      setIsActiveRenameButton(true);
    } else {
      setIsActiveRenameButton(false);
    }
  };

  // rename scenario request
  useEffect(() => {
    if (!isNeedRenameScenario) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "PUT",
          headers: headerService(),
          body: JSON.stringify(requestDTO),
        }).then(() => {
          if (props?.id === scenarioSimulateID) {
            updateScenarioName();
          }
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
    setIsNeedRenameScenario(false);
    setRequestPath();
    setRequestDTO();
  }, [isNeedRenameScenario]);

  // show delete scenario modal
  const showDeleteScenarioWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "deleteTemplate") {
      setRequestPath(TEMPLATE_PATH_PREFIX + props?.id);
    }
    if (event.target.id === "deleteScenario") {
      setRequestPath(SCENARIO_PATH_PREFIX + props?.id);
    }
    setIsShowDeleteScenarioWindow(true);
  };

  // hide delete scenario modal
  const closeDeleteScenarioWindow = (event) => {
    event.preventDefault();
    setIsShowDeleteScenarioWindow(false);
    hideAllContextButtons();
  };

  // flag to request delete scenario
  const handleSubmitDeleteScenario = (event) => {
    event.preventDefault();
    setIsNeedDeleteScenario(true);
  };

  // delete scenario request
  useEffect(() => {
    if (!isNeedDeleteScenario) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "DELETE",
          headers: headerService(),
        }).then(() => {
          if (simScenarioId === props?.id || simTemplateId === props?.id) {
            dispatch({
              type: "NEW_SCENARIO_SIMULATED_ID",
              payload: null,
            });
            dispatch({
              type: "NEW_TEMPLATE_SIMULATED_ID",
              payload: null,
            });
          }
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
  }, [isNeedDeleteScenario]);

  // show duplicate scenario modal
  const showDuplicateScenarioWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "duplicateTemplate") {
      setRequestPath(DUPLICATE_TEMPLATE_PATH);
    }
    if (event.target.id === "duplicateScenario") {
      setRequestPath(DUPLICATE_SCENARIO_PATH);
    }
    setIsShowDuplicateScenarioWindow(true);
  };

  // hide duplicate scenario modal
  const closeDuplicateScenarioWindow = (event) => {
    event.preventDefault();
    setIsShowDuplicateScenarioWindow(false);
    hideAllContextButtons();
  };

  // flag to request duplicate scenario
  const handleSubmitDuplicateScenario = (event) => {
    event.preventDefault();

    console.log(duplicateScenarioName);

    setRequestDTO({
      newScenarioName: duplicateScenarioName,
      scenarioId: props.id,
    });
    setIsNeedDuplicateScenario(true);
  };

  // update new scenario name
  const handleChangeDuplicateScenarioName = (event) => {
    event.preventDefault();
    if (event.target.value.length) {
      console.log(event.target?.value);
      setDuplicateScenarioName(event.target?.value);
      setIsActiveDuplicateButton(true);
    } else {
      setIsActiveDuplicateButton(false);
    }
  };

  // duplicate scenario request
  useEffect(() => {
    if (!isNeedDuplicateScenario) {
      return;
    }

    console.log(requestDTO);
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "PUT",
          headers: headerService(),
          body: JSON.stringify(requestDTO),
        }).then(() => {
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
    setRequestDTO();
    setRequestPath();
    setDuplicateScenarioName();
    setIsNeedDuplicateScenario(false);
  }, [isNeedDuplicateScenario]);

  // show copy scenario modal
  const showCopyScenarioWindow = (event) => {
    event.preventDefault();
    if (tree?.scenariosTree.length === 0) {
      setCopyScenarioTitle(
        "You don't have any folder to save the scenario, first create a folder in my scenarios"
      );
      setIsActiveCopyScenarioButton(false);
    } else {
      setCopyScenarioTitle("Destination for copy standard scenario");
      setIsActiveCopyScenarioButton(true);
    }
    setIsShowCopyScenarioWindow(true);
  };

  // hide copy scenario modal
  const hideCopyScenarioWindow = (event) => {
    event.preventDefault();
    setIsShowCopyScenarioWindow(false);
    hideAllContextButtons();
  };

  // flag to request copy scenario
  const handleSubmitCopyScenario = (event) => {
    event.preventDefault();
    setRequestPath(
      COPY_PATH + destinationFolderId + COPY_PATH_POSTFIX + props?.id
    );
    setIsNeedCopyScenario(true);
    dispatch({
      type: "SET_FOLDER_ID_FOR_COPY",
      payload: null,
    });
  };

  // copy scenario request
  useEffect(() => {
    if (!isNeedCopyScenario) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "POST",
          headers: headerService(),
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
    fullReset();
  }, [isNeedCopyScenario]);

  // create new user folder, if user have not any folder
  const handleCreateNewFolder = (event) => {
    event.preventDefault();
    dispatch({
      type: "CREATE_FIRST_USER_FOLDER",
      payload: true,
    });
    fullReset();
  };

  // handle press ENTER in rename scenario modal
  useEffect(() => {
    if (!onPressEnterModalRenameScenario) {
      return;
    }
    setRequestDTO({
      newScenarioName: newScenarioName,
      scenarioId: props.id,
    });
    setIsNeedRenameScenario(true);
    setOnPressEnterModalRenameScenario(false);
  }, [onPressEnterModalRenameScenario]);

  // handle press ENTER in duplicate scenario modal
  useEffect(() => {
    if (!onPressEnterModalDuplicateScenario) {
      return;
    }
    setRequestDTO({
      newScenarioName: duplicateScenarioName,
      scenarioId: props.id,
    });
    setIsNeedDuplicateScenario(true);
    setOnPressEnterModalDuplicateScenario(false);
  }, [onPressEnterModalDuplicateScenario]);

  return (
    <div 
    onMouseLeave={(e) => setShowButtonsGroup("")} className={isShowButtonsGroup === props?.id ? "" : "hide"}>
      {isTemplateContext() && (
        <FileContextButton
          id="renameTemplate"
          handler={(e) => showRenameScenarioWindow(e)}
          title="Rename scenario"
        />
      )}
      {isTemplateContext() && (
        <FileContextButton
          id="deleteTemplate"
          handler={(e) => showDeleteScenarioWindow(e)}
          title="Delete scenario"
        />
      )}
      {(user?.role === "ADMIN" || user?.role === "CLIENT") &&
        props.isTemplate && (
          <FileContextButton
            id="downloadTemplate"
            handler={(e) => handleDownloadFile(e)}
            title="Download scenario"
          />
        )}
      {isTemplateContext() && (
        <FileContextButton
          id="duplicateTemplate"
          handler={(e) => showDuplicateScenarioWindow(e)}
          title="Duplicate scenario"
        />
      )}

      {user?.role === "CLIENT" && props.isTemplate && (
        <FileContextButton
          id="duplicateTemplate"
          handler={(e) => showCopyScenarioWindow(e)}
          title="Copy to my scenarios"
        />
      )}
      {isScenarioContext() && (
        <FileContextButton
          id="renameScenario"
          handler={(e) => showRenameScenarioWindow(e)}
          title="Rename scenario"
        />
      )}
      {isScenarioContext() && (
        <FileContextButton
          id="deleteScenario"
          handler={(e) => showDeleteScenarioWindow(e)}
          title="Delete scenario"
        />
      )}
      {isScenarioContext() && (
        <FileContextButton
          id="downloadScenario"
          handler={(e) => handleDownloadFile(e)}
          title="Download scenario"
        />
      )}
      {isScenarioContext() && (
        <FileContextButton
          id="duplicateScenario"
          handler={(e) => showDuplicateScenarioWindow(e)}
          title="Duplicate scenario"
        />
      )}
      <FileContextButton
        id="duplicateTemplate"
        handler={(e) => simulateIt(e)}
        title="Run simulation"
      />
      <ModalRename
        onHide={(e) => closeRenameScenarioWindow(e)}
        isShowWindow={isShowRenameScenarioWindow}
        handleRename={(e) => handleSubmitRenameScenario(e)}
        newName={(e) => handleChangeNewScenarioName(e)}
        oldName={props?.scenarioName}
        title={RENAME_SCENARIO}
        setOnPressEnter={setOnPressEnterModalRenameScenario}
        buttonTittle={"RENAME SCENARIO"}
        tooltip={INPUT_RENAME_SCENARIO_TOOLTIP}
        isActiveRenameButton={isActiveRenameButton}
      />
      <ModalDelete
        onHide={(e) => closeDeleteScenarioWindow(e)}
        isShowWindow={isShowDeleteScenarioWindow}
        handleDelete={(e) => handleSubmitDeleteScenario(e)}
        parentFolderName={props.scenarioName}
        title={DELETE_SCENARIO}
        buttonTittle={DELETE_SCENARIO_BUTTON_TITTLE}
      />
      <ModalDuplicate
        onHide={(e) => closeDuplicateScenarioWindow(e)}
        isShowWindow={isShowDuplicateScenarioWindow}
        handleRename={(e) => handleSubmitDuplicateScenario(e)}
        newName={(e) => handleChangeDuplicateScenarioName(e)}
        oldName={"Copy of " + props?.scenarioName}
        setOnPressEnter={setOnPressEnterModalDuplicateScenario}
        title={DUPLICATE_SCENARIO}
        buttonTittle={"DUPLICATE SCENARIO"}
        tooltip={INPUT_DUPLICATE_SCENARIO_TOOLTIP}
        isActiveRenameButton={isActiveDuplicateButton}
      />
      <ModalCopyScenario
        onHide={(e) => hideCopyScenarioWindow(e)}
        isShowWindow={isShowCopyScenarioWindow}
        handle={(e) => handleSubmitCopyScenario(e)}
        handleCreateNewFolder={(e) => handleCreateNewFolder(e)}
        parentFolderName={props.scenarioName}
        title={copyScenarioTitle}
        tree={tree}
        isActiveCopyScenarioButton={isActiveCopyScenarioButton}
      />
    </div>
  );
};

const FolderContextMenu = (props) => {
  const user = useContext(UserContext);
  const [creationFolderParentId, setCreationFolderParentId] = useState(
    props?.id
  );
  const [errorMsg, setErrorMsg] = useState();

  const [requestPath, setRequestPath] = useState("");
  const [requestDTO, setRequestDTO] = useState();

  const [isShowCreateNewFolderWindow, setIsShowCreateNewFolderWindow] =
    useState();
  const [isShowUploadScenarioWindow, setIsShowUploadScenarioWindow] =
    useState();
  const [isShowRenameFolderWindow, setIsShowRenameFolderWindow] = useState();
  const [isShowDeleteFolderWindow, setIsShowDeleteFolderWindow] = useState();

  const [newFolderName, setNewFolderName] = useState("");
  const [creationFolderName, setCreationFolderName] = useState();
  const [file, setFile] = useState();

  const navigate = useNavigate();
  const BEARER = authStorage();

  const PATH_POSTFIX = "/scenarios";
  const TEMPLATE_FOLDER_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/templatestree/folders";
  const SCENARIO_FOLDER_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/scenariostree/folders";

  const CREATE_NEW_FOLDER_TITLE = `Create new folder inside '${props.parentFolderName}'`;
  const UPLOAD_TEMPLATE_TITLE = `Upload scenario inside '${props.parentFolderName}' (max size=1MB)`;
  const RENAME_FOLDER = `Rename folder '${props.parentFolderName}'`;
  const DELETE_FOLDER = `Delete folder '${props.parentFolderName}' and all its subfolders and scenarios?`;
  const DELETE_BUTTON_TITLE = "DELETE FOLDER";
  const INPUT_RENAME_FOLDER_TOOLTIP = "New folder name";

  const [isActiveRenameButton, setIsActiveRenameButton] = useState();
  const [isNeedRenameFolder, setIsNeedRenameFolder] = useState();
  const [isNeedDeleteFolder, setIsNeedDeleteFolder] = useState();
  const [isNeedNewFolderCreate, setIsNeedNewFolderCreate] = useState();

  const [onPressEnterModalRenameFolder, setOnPressEnterModalRenameFolder] =
    useState(false);
  const [onPressEnterModalNewFolder, setOnPressEnterModalNewFolder] =
    useState(false);

  const dispatch = useDispatch();
  const MAX_FILE_SIZE = 1048576;
  const SCENARIO_EXTENSION = ".xlsx";
  const [maxFileSizeError, setMaxFileSizeError] = useState();
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [isActiveUploadScenarioButton, setIsActiveUploadScenarioButton] =
    useState(false);

    const isShowFolderContextMenu = useSelector(
      (state) => state.isShowFolderContextMenu
    );

  // hide scenarios and folders context menu buttons,
  // when send request or close modal windows
  const hideAllContextButtons = () => {
    dispatch({
      type: "SET_IS_SHOW_BUTTONS_GROUP",
      payload: "",
    });
    dispatch({
      type: "SET_IS_SHOW_FOLDER_CONTEXT_MENU",
      payload: "",
    });
  };

  // flag to update scenarios tree
  const updateTree = () => {
    dispatch({
      type: "UPDATE_FOLDER_TREE",
      payload: 1,
    });
  };

  // reset
  const fullReset = () => {
    setIsNeedRenameFolder(false);
    setIsNeedDeleteFolder(false);
    setIsNeedNewFolderCreate(false);
    setNewFolderName("");
    setIsShowRenameFolderWindow(false);
    updateTree();
    setRequestDTO("");
    setIsShowDeleteFolderWindow(false);
    setRequestPath("");
    setCreationFolderName();
    hideAllContextButtons();
    setIsShowUploadScenarioWindow();
    // setFile();
  };

  // redirect without auth
  const redirectIfNotAuth = (response) => {
    if (response.status === 401) {
      navigate("/login");
    }
  };

  // create new folder request
  useEffect(() => {
    if (!isNeedNewFolderCreate) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "POST",
          headers: headerService(),
          body: JSON.stringify(requestDTO),
        }).then(() => {
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
  }, [isNeedNewFolderCreate]);

  // flag to request create new folder
  const createNewFolder = (event) => {
    event.preventDefault();
    setRequestDTO({
      parentId: creationFolderParentId,
      name: creationFolderName,
    });
    setIsNeedNewFolderCreate(true);
    setIsShowCreateNewFolderWindow(false);
  };

  // show create new folder modal
  const showCreateNewFolderWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "createTemplateFolder") {
      setRequestPath(TEMPLATE_FOLDER_PATH);
    }
    if (event.target.id === "createScenarioFolder") {
      setRequestPath(SCENARIO_FOLDER_PATH);
    }
    setCreationFolderParentId(props?.id);
    setIsShowCreateNewFolderWindow(true);
  };

  // hide create new folder modal
  const closeCreateNewFolderWindow = (event) => {
    event.preventDefault();
    setIsShowCreateNewFolderWindow(false);
    setRequestPath();
    setCreationFolderName();
    hideAllContextButtons();
  };

  // update new folder name
  const handleNewFolderName = (event) => {
    event.preventDefault();
    setCreationFolderName(event.target.value);
  };

  // choose file for upload
  function handleChooseFile(event) {
    if (event.target.files[0].name.endsWith(SCENARIO_EXTENSION) !== true) {
      setIsActiveUploadScenarioButton(false);
      setMaxFileSizeError("Please choose file with 'xlsx' extension");
    } else if (event.target.files[0].size > MAX_FILE_SIZE) {
      setIsActiveUploadScenarioButton(false);
      setMaxFileSizeError("Selected file is greater 1 MB");
    } else {
      setMaxFileSizeError();
      setFile(event.target.files[0]);
      setIsActiveUploadScenarioButton(true);
    }
  }

  // upload file to server
  function handleSubmit(event) {
    event.preventDefault();
    if (!file) {
      setErrorMsg("Please choose a file");
      return;
    } else {
      setIsLoadingFile(true);
      const url = requestPath;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", file.name);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: BEARER,
        },
      };
      axiosBaseUrl
        .post(url, formData, config)
        .then((response) => {
          redirectIfNotAuth(response);
          if (response.status === 400) {
            const msg = response.text();
            setErrorMsg(msg.substring(10, msg.length - 2));
            return;
          }
        })
        .then(() => {
          fullReset();
        })
        .catch((error) => {
          fullReset();
        });
    }
  }

  // show upload file modal
  const showUploadScenarioWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "uploadToTemplateFolder") {
      setRequestPath(
        TEMPLATE_FOLDER_PATH + "/" + creationFolderParentId + PATH_POSTFIX
      );
    }
    if (event.target.id === "uploadToScenarioFolder") {
      setRequestPath(
        SCENARIO_FOLDER_PATH + "/" + creationFolderParentId + PATH_POSTFIX
      );
    }
    setIsShowUploadScenarioWindow(true);
  };

  // hide upload file modal
  const closeUploadFileWindow = (event) => {
    event.preventDefault();
    setIsShowUploadScenarioWindow();
    hideAllContextButtons();
  };

  // hide rename folder modal
  const closeRenameFolderWindow = (event) => {
    event.preventDefault();
    setIsShowRenameFolderWindow(false);
    hideAllContextButtons();
  };

  // show rename folder modal
  const showRenameFolderWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "renameTemplateFolder") {
      setRequestPath(TEMPLATE_FOLDER_PATH);
    }
    if (event.target.id === "renameScenarioFolder") {
      setRequestPath(SCENARIO_FOLDER_PATH);
    }
    setIsShowRenameFolderWindow(true);
  };

  // rename folder request
  useEffect(() => {
    if (!isNeedRenameFolder) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "PUT",
          headers: headerService(),
          body: JSON.stringify(requestDTO),
        }).then(() => {
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
  }, [isNeedRenameFolder]);

  // flag to request rename folder
  const handleSubmitRenameFolder = (event) => {
    event.preventDefault();
    setRequestDTO({
      newFolderName: newFolderName,
      folderId: props.id,
    });
    setIsNeedRenameFolder(true);
  };

  // update new folder name
  const handleChangeNewFolderName = (event) => {
    event.preventDefault();
    if (
      event.target.value.length &&
      event.target.value !== props?.parentFolderName
    ) {
      setIsActiveRenameButton(true);
      setNewFolderName(event.target.value);
    } else {
      setIsActiveRenameButton(false);
    }
  };

  // show delete folder modal
  const showDeleteFolderWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "deleteTemplateFolder") {
      setRequestPath(TEMPLATE_FOLDER_PATH + "/" + props?.id);
    }
    if (event.target.id === "deleteScenarioFolder") {
      setRequestPath(SCENARIO_FOLDER_PATH + "/" + props?.id);
    }
    setIsShowDeleteFolderWindow(true);
  };

  // hide delete folder modal
  const closeDeleteFolderWindow = (event) => {
    event.preventDefault();
    setIsShowDeleteFolderWindow(false);
    hideAllContextButtons();
  };

  // flag to request delete folder
  const submitDeleteFolder = (event) => {
    event.preventDefault();
    setIsNeedDeleteFolder(true);
  };

  // delete folder request
  useEffect(() => {
    if (!isNeedDeleteFolder) {
      return;
    }
    const sendRequest = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "DELETE",
          headers: headerService(),
        }).then(() => {
          fullReset();
        });
        redirectIfNotAuth(response);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    sendRequest();
  }, [isNeedDeleteFolder]);

  // show only for templates tree
  const isTemplateContext = () => {
    return user?.role === "ADMIN" && props.isTemplate;
  };

  // show only for scenarios tree
  const isScenarioContext = () => {
    return user?.role === "CLIENT" && !props.isTemplate;
  };

  // handle ENTER press for rename folder
  useEffect(() => {
    if (!onPressEnterModalRenameFolder) {
      return;
    }
    setRequestDTO({
      newFolderName: newFolderName,
      folderId: props.id,
    });
    setIsNeedRenameFolder(true);
    setOnPressEnterModalRenameFolder(false);
  }, [onPressEnterModalRenameFolder]);

  // handle ENTER press for create new folder
  useEffect(() => {
    if (!onPressEnterModalNewFolder) {
      return;
    }
    setRequestDTO({
      parentId: creationFolderParentId,
      name: creationFolderName,
    });
    setIsNeedNewFolderCreate(true);
    setIsShowCreateNewFolderWindow(false);
    setOnPressEnterModalNewFolder(false);
  }, [onPressEnterModalNewFolder]);

  return (
    <div 
    className={isShowFolderContextMenu === props?.id ? "scenario-context-menu" : "scenario-context-menu hide"}
    >
      {isTemplateContext() && (
        <FolderContextButton
          id="createTemplateFolder"
          handler={(e) => showCreateNewFolderWindow(e)}
          title="New folder"
        />
      )}
      {isTemplateContext() && (
        <FolderContextButton
          id="renameTemplateFolder"
          handler={(e) => showRenameFolderWindow(e)}
          title="Rename folder"
        />
      )}
      {isTemplateContext() && (
        <FolderContextButton
          id="deleteTemplateFolder"
          handler={(e) => showDeleteFolderWindow(e)}
          title="Delete folder"
        />
      )}
      {isTemplateContext() && (
        <FolderContextButton
          id="uploadToTemplateFolder"
          handler={(e) => showUploadScenarioWindow(e)}
          title="Upload scenario"
        />
      )}
      {isScenarioContext() && (
        <FolderContextButton
          id="createScenarioFolder"
          handler={(e) => showCreateNewFolderWindow(e)}
          title="New folder"
        />
      )}
      {isScenarioContext() && (
        <FolderContextButton
          id="renameScenarioFolder"
          handler={(e) => showRenameFolderWindow(e)}
          title="Rename folder"
        />
      )}
      {isScenarioContext() && (
        <FolderContextButton
          id="deleteScenarioFolder"
          handler={(e) => showDeleteFolderWindow(e)}
          title="Delete folder"
        />
      )}
      {isScenarioContext() && (
        <FolderContextButton
          id="uploadToScenarioFolder"
          handler={(e) => showUploadScenarioWindow(e)}
          title="Upload scenario"
        />
      )}
      <ModalCreateNewFolder
        onHide={(e) => closeCreateNewFolderWindow(e)}
        isShowWindow={isShowCreateNewFolderWindow}
        handleCreateNewFolder={(e) => createNewFolder(e)}
        folderName={(e) => handleNewFolderName(e)}
        parentFolderName={props.name}
        title={CREATE_NEW_FOLDER_TITLE}
        setOnPressEnter={setOnPressEnterModalNewFolder}
        isActiveCreateNewFolderButton={creationFolderName}
      />
      <ModalUploadFile
        onHide={(e) => closeUploadFileWindow(e)}
        isShowWindow={isShowUploadScenarioWindow}
        parentFolderName={props.name}
        title={UPLOAD_TEMPLATE_TITLE}
        handleSubmit={(e) => handleSubmit(e)}
        handleChooseFile={(e) => handleChooseFile(e)}
        isActiveUploadFileButton={isActiveUploadScenarioButton}
        buttonTittle={"UPLOAD SCENARIO"}
        errorMessage={maxFileSizeError}
        isShowLoader={isLoadingFile}
      />
      <ModalRename
        onHide={(e) => closeRenameFolderWindow(e)}
        isShowWindow={isShowRenameFolderWindow}
        handleRename={(e) => handleSubmitRenameFolder(e)}
        newName={(e) => handleChangeNewFolderName(e)}
        setOnPressEnter={setOnPressEnterModalRenameFolder}
        oldName={props?.parentFolderName}
        title={RENAME_FOLDER}
        buttonTittle={"RENAME FOLDER"}
        tooltip={INPUT_RENAME_FOLDER_TOOLTIP}
        isActiveRenameButton={isActiveRenameButton}
      />
      <ModalDelete
        onHide={(e) => closeDeleteFolderWindow(e)}
        isShowWindow={isShowDeleteFolderWindow}
        handleDelete={(e) => submitDeleteFolder(e)}
        parentFolderName={props.parentFolderName}
        title={DELETE_FOLDER}
        buttonTittle={DELETE_BUTTON_TITLE}
      />
    </div>
  );
};

export default Node2;
